import { Size } from '../types';
export const generateName = ({
    size,
    position,
    uuid
}: {
    size: Size;
    position: number;
    uuid?: number;
}): string => {
    return `dfp_${
        typeof size === 'string' ? size : size.join('x')
    }_${position}${uuid ? `_${uuid}` : ''}`;
};
